module.exports = __webpack_public_path__ + "img/standard.2bc6f635.png";